<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card p-1 pb-2">
            <div class="row">
              <div class="col-md-4">
                <h5>Dasp Nº {{ dasp.dasp_number }}</h5>
                <h6>Data: {{ dasp.created_at_f }}</h6>
              </div>
              <div class="col-md-8 row justify-content-end">
                <div>
                  <!-- usa computed seguro para evitar 'undefined.class' -->
                  <span v-if="currentStatus" class="badge" :class="'badge-' + currentStatus.class">
                    {{ currentStatus.name }}
                  </span>
                </div>
                <div>
                  <button class="btn btn-add btn-crud ml-1 p-0" data-toggle="modal" data-target="#modalNotes">
                    <span class="notification-badge" v-if="notes.length">
                      {{ notes.length }}
                    </span>
                    <i class="fas fa-comment"></i>
                  </button>
                  <div class="modal fade" id="modalNotes" tabindex="-1" role="dialog" aria-labelledby="modalNotesTitle"
                    aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                      <div class="modal-content">
                        <div class="modal-header bg-primary">
                          <h5 class="modal-title text-light">
                            Observações ({{ notes.length }})
                          </h5>
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body">
                          <div class="row">
                            <div class="col-12" v-for="note in notes" :key="note.id">
                              <b>
                                <h5>
                                  {{ note.user.name }} ({{ note.created_at_f }})
                                </h5>
                              </b>
                              <h6>
                                {{ note.text }}
                              </h6>
                              <hr />
                            </div>
                          </div>
                        </div>
                        <div class="modal-footer">
                          <textarea cols="30" rows="4" class="form-control" v-model="text"></textarea>
                          <button class="btn btn-secondary" data-dismiss="modal">
                            Cancelar
                          </button>
                          <button class="btn btn-primary" data-dismiss="modal" @click="addNote()">
                            Salvar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 mt-4 mb-2">
                <div :class="[
                  'dasp-card',
                  $store.state.appConfig.layout.skin === 'dark'
                    ? 'dasp-card-dark'
                    : 'dasp-card-light',
                ]">
                  <div class="dasp-card-header">
                    <i class="fas fa-clipboard-list text-primary" style="font-size: 22px"></i>
                    <h3 class="mb-0 text-primary dasp-card-title">
                      Detalhes da DASP
                    </h3>
                    <div class="dasp-card-line dasp-card-line-primary"></div>
                  </div>

                  <div class="row">
                    <div class="col-md-4">
                      <label class="dasp-label">Tipo de Compra</label>
                      <v-select v-model="dasp.purchase_type_id" :options="purchase_types"
                        :reduce="(purchase_types) => purchase_types.id" :label="'name'" disabled
                        class="dasp-select"></v-select>
                    </div>
                    <div class="col-md-12">
                      <label :class="$store.state.appConfig.layout.skin === 'dark'
                          ? 'dasp-label-dark'
                          : 'dasp-label-light'
                        ">Centro de Custo</label>
                      <v-select :key="dasp.bill_center_id
                          ? dasp.bill_center_id.join('-')
                          : 'empty'
                        " v-model="dasp.bill_center_id" :options="billCenter" :reduce="(billCenter) => billCenter.id"
                        :label="'number_name'" multiple :disabled="!isAccessNivel8 || dasp.status === 4"
                        :clearable="true" :close-on-select="false" :class="[
                          'dasp-select',
                          $store.state.appConfig.layout.skin === 'dark'
                            ? 'dasp-select-dark'
                            : 'dasp-select-light',
                        ]" />
                    </div>
                    <div class="col-md-12">
                      <label class="dasp-label">Colaborador</label>
                      <v-select v-model="dasp.collaborator" :options="users" :reduce="(users) => users.id"
                        :label="'name'" :disabled="!isAccessNivel8 || dasp.status === 4" class="dasp-select"></v-select>
                    </div>
                    <div class="col-md-4">
                      <label class="dasp-label">Destino desta aquisição</label>
                      <v-select v-model="dasp.destination" :options="acquisitions"
                        :reduce="(acquisitions) => acquisitions.id" :label="'name'" :disabled="!(
                            [2, 3].includes(current_manager.action) &&
                            current_manager.user_id === $store.state.user.id
                          )
                          " class="dasp-select"></v-select>
                    </div>
                    <div class="col-md-4">
                      <label class="dasp-label">Prioridade</label>
                      <v-select v-model="dasp.term" :options="term" :reduce="(term) => term.id" :label="'name'"
                        :disabled="!(
                            [2, 3].includes(current_manager.action) &&
                            current_manager.user_id === $store.state.user.id
                          )
                          " class="dasp-select"></v-select>
                    </div>
                    <div class="col-md-2">
                      <label class="dasp-label">Valor Orçado</label>
                      <input type="text" class="form-control dasp-input" :value="formatBRL(totalBudget)"
                        v-money="moneyConfig" disabled readonly />
                    </div>
                    <div class="col-md-2">
                      <label class="dasp-label">Valor Pago</label>
                      <input type="text" class="form-control dasp-input" :value="formatBRL(totalPaid)"
                        v-money="moneyConfig" disabled readonly />
                    </div>
                    <div class="col-md-12">
                      <label class="dasp-label">Observação</label>
                      <textarea class="form-control dasp-input" v-model="dasp.observation" rows="3" disabled></textarea>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 mt-4 mb-2">
                <div :class="[
                  'dasp-card',
                  $store.state.appConfig.layout.skin === 'dark'
                    ? 'dasp-card-dark'
                    : 'dasp-card-light',
                ]">
                  <div class="dasp-card-header">
                    <i class="fas fa-box text-success" style="font-size: 22px"></i>
                    <h3 class="mb-0 text-success dasp-card-title">
                      Detalhes do produto/serviço
                    </h3>
                    <div class="dasp-card-line" style="border-color: #28a745; margin-bottom: 2px"></div>
                  </div>

                  <div class="text-right mb-2" v-if="dasp.status == 1">
                    <button class="btn btn-outline-info ml-2 mt-3 mb-2" type="button" data-toggle="collapse"
                      data-target="#collapseNovoProduto" aria-expanded="false" aria-controls="collapseNovoProduto">
                      <i class="fa fa-plus"></i> Adicionar novo item
                    </button>
                  </div>

                  <div class="collapse mb-2" id="collapseNovoProduto">
                    <div :class="[
                      'card card-body',
                      $store.state.appConfig.layout.skin === 'dark'
                        ? 'dasp-inner-card-dark'
                        : 'dasp-inner-card-light',
                    ]">
                      <div class="row align-items-end">
                        <div class="col-md-3 mb-2">
                          <label :class="$store.state.appConfig.layout.skin === 'dark'
                              ? 'dasp-label-dark'
                              : 'dasp-label-light'
                            ">Descrição</label>
                          <input v-model="novoProduto.name" class="form-control dasp-input" placeholder="Descrição" />
                        </div>
                        <div class="col-md-3 mb-2">
                          <label class="dasp-label">Quantidade</label>
                          <input v-model="novoProduto.quantity_requested" class="form-control dasp-input" type="number"
                            placeholder="Quantidade" @keydown="preventInvalidInput" min="1" />
                        </div>
                        <div class="col-md-3 mb-2">
                          <label class="dasp-label">Valor Orçado</label>
                          <input v-model="novoProduto.budget" class="form-control dasp-input" placeholder="Valor Orçado"
                            v-money="moneyConfig" />
                        </div>
                        <div class="col-md-3 mb-2">
                          <label class="dasp-label">Link</label>
                          <input v-model="novoProduto.link" class="form-control dasp-input" placeholder="Link" />
                        </div>
                        <div class="col-12 text-right mt-2">
                          <button class="btn btn-success px-4" @click="adicionarProdutoEPartialSave">
                            <i class="fa fa-check"></i> Adicionar Item
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="mt-3" style="width: 100%; overflow-x: auto">
                    <table class="table table-bordered align-middle tabela-leitura"
                      style="width: 100%; min-width: 1150px">
                      <thead>
                        <tr class="text-center">
                          <th>DESCRIÇÃO</th>
                          <th>LINK</th>
                          <th>QTD SOL./ATENDIDA</th>
                          <th>FORNECEDOR</th>
                          <th>PRAZO</th>
                          <th>ORÇADO / PAGO</th>
                          <th>ANEXO</th>
                          <th>AÇÃO</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(product, index) in list" :key="index" :class="{
                          'item-not-approved':
                            !product.approved && dasp.status !== 1,
                        }">
                          <td>
                            <span>{{ product.name || "" }}</span>
                          </td>
                          <td>
                            <span v-if="product.link">
                              <a :href="product.link" target="_blank" style="color: #5cd3ff" :title="product.link">
                                {{
                                  product.link.length > 100
                                    ? product.link.substring(0, 100) + "..."
                                    : product.link
                                }}
                              </a>
                            </span>
                            <span v-else style="color: #888">—</span>
                          </td>
                          <!-- QTD SOL./ATENDIDA -->
                          <td class="text-center">
                            <div class="d-flex align-items-center justify-content-center" style="gap: 6px">
                              <span>{{ product.quantity_requested || 0 }}</span>
                              <span>/</span>
                              <input type="number" min="0" class="form-control form-control-sm" style="width: 90px"
                                v-model.number="product.quantity_delivered" :disabled="!product.approved ||
                                  !(
                                    [1, 2, 3].includes(
                                      current_manager.action
                                    ) &&
                                    current_manager.user_id ===
                                    $store.state.user.id
                                  )
                                  " @input="onInlineEdit()" @keydown="preventInvalidInput" />
                            </div>
                          </td>

                          <!-- FORNECEDOR -->
                          <td>
                            <input type="text" class="form-control form-control-sm" v-model="product.supplier"
                              :disabled="!product.approved ||
                                !(
                                  [1, 2, 3].includes(current_manager.action) &&
                                  current_manager.user_id ===
                                  $store.state.user.id
                                )
                                " @input="onInlineEdit()" placeholder="Fornecedor" />
                          </td>

                          <!-- PRAZO (data) -->
                          <td>
                            <input type="date" class="form-control form-control-sm" v-model="product.term" :disabled="!product.approved ||
                              !(
                                [1, 2, 3].includes(current_manager.action) &&
                                current_manager.user_id ===
                                $store.state.user.id
                              )
                              " @change="onInlineEdit()" min="2000-01-01" max="9999-12-31" />
                          </td>

                          <!-- ORÇADO / PAGO -->
                          <td class="text-center">
                            <div class="d-flex align-items-center justify-content-center" style="gap: 6px">
                              <span>{{
                                getTotalBudgetForProduct(product)
                                }}</span>
                              <span v-if="product.budget"> / </span>
                              <input type="text" class="form-control form-control-sm" style="width: 140px"
                                v-model="product.paid" v-money="moneyConfig" :disabled="!product.approved ||
                                  !(
                                    [1, 2, 3].includes(
                                      current_manager.action
                                    ) &&
                                    current_manager.user_id ===
                                    $store.state.user.id
                                  )
                                  " @input="onInlineEdit(true)" placeholder="R$ 0,00" />
                            </div>
                          </td>

                          <!-- ANEXO -->
                          <td>
                            <div v-for="doc in productDocs(product.id)" :key="doc.id"
                              class="d-flex align-items-center mb-1">
                              <a :href="doc.file_link" target="_blank" class="mr-2">{{ doc.description }}</a>
                              <button v-if="isAccessNivel8" type="button" class="close ml-auto"
                                aria-label="Remover anexo" title="Remover anexo"
                                @click="abrirModalRemocaoArquivo(doc.id)">
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <span v-if="!productDocs(product.id).length" style="color: #888">—</span>
                          </td>

                          <td class="text-center">
                            <template v-if="dasp.status === 1">
                              <input type="checkbox" v-model="product.approved" :disabled="dasp.status != 1 ||
                                !(
                                  [1, 2, 3].includes(current_manager.action) &&
                                  current_manager.user_id ===
                                  $store.state.user.id
                                )
                                " style="transform: scale(1.25); margin-right: 8px"
                                title="Selecionar produto para aprovar" />

                              <button v-if="list.length > 1" class="btn-remove" @click="abrirModalRemocao(index)"
                                :disabled="dasp.status != 1 ||
                                  !(
                                    [1, 2, 3].includes(current_manager.action) &&
                                    current_manager.user_id ===
                                    $store.state.user.id
                                  )
                                  " title="Remover item" style="vertical-align: middle">
                                <i class="fas fa-trash"></i>
                              </button>
                            </template>

                            <button class="btn-attach ml-1" title="Adicionar arquivo" aria-label="Adicionar arquivo"
                              style="vertical-align: middle" @click="productDocUpload.productId = product.id">
                              <i class="fas fa-paperclip"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <!-- Modal de confirmação -->
                    <transition name="modal-fade" appear>
                      <div v-if="showConfirmModal" class="confirm-overlay">
                        <div class="confirm-card">
                          <p>Tem certeza que deseja remover este produto?</p>
                          <button class="btn btn-danger btn-sm mr-2" @click="confirmarRemocao">
                            Sim
                          </button>
                          <button class="btn btn-secondary btn-sm" @click="cancelarRemocao">
                            Cancelar
                          </button>
                        </div>
                      </div>
                    </transition>
                  </div>
                  <div class="mt-3" style="width: 96%; margin: 0 2%; overflow-x: auto">
                    <div class="text-right mb-2" v-if="dasp.status == 1 &&
                      [1, 2, 3].includes(current_manager.action) &&
                      current_manager.user_id === $store.state.user.id
                      ">
                      <button class="btn btn-success" @click="approveAllProducts">
                        <i class="fa fa-check"></i> Marcar todos
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 mt-5 mb-5">
                <div :class="[
                  'dasp-card',
                  $store.state.appConfig.layout.skin === 'dark'
                    ? 'dasp-card-dark'
                    : 'dasp-card-light',
                ]">
                  <div class="dasp-card-header">
                    <i class="fas fa-store text-primary" style="font-size: 22px"></i>
                    <h3 class="mb-0 text-primary dasp-card-title">
                      Detalhes do pagamento
                    </h3>
                    <div class="dasp-card-line dasp-card-line-primary"></div>
                  </div>

                  <div class="text-right mb-2" v-if="
                    [2, 3].includes(current_manager.action) &&
                    current_manager.user_id === $store.state.user.id
                  ">
                    <button class="btn btn-primary ml-2 mt-3 mb-2" type="button"
                      @click="showNovoFornecedor = !showNovoFornecedor">
                      <i :class="showNovoFornecedor ? 'fa fa-minus' : 'fa fa-plus'
                        "></i>
                      {{ showNovoFornecedor ? " Fechar" : "Adicionar novo" }}
                    </button>
                  </div>

                  <div v-if="
                    showNovoFornecedor &&
                    [2, 3].includes(current_manager.action) &&
                    current_manager.user_id === $store.state.user.id
                  " :class="[
                      'card card-body mb-2',
                      $store.state.appConfig.layout.skin === 'dark'
                        ? 'dasp-inner-card-dark'
                        : 'dasp-inner-card-light',
                    ]">
                    <div class="row align-items-end">
                      <div class="col-md-2 mb-2">
                        <label :class="$store.state.appConfig.layout.skin === 'dark'
                            ? 'dasp-label-dark'
                            : 'dasp-label-light'
                          ">Loja</label>
                        <input type="text" class="form-control dasp-input" v-model="supplier.name" placeholder="Loja" />
                      </div>
                      <div class="col-md-2 mb-2">
                        <label class="dasp-label">Método</label>
                        <v-select v-model="supplier.method" :options="payment" :reduce="(payment) => payment.id"
                          :label="'name'" class="dasp-select"></v-select>
                        <input type="text" class="form-control dasp-input mt-1" v-model="supplier.last_digits"
                          placeholder="Dígitos" v-if="supplier.method === 1" maxlength="4" style="width: 80px" />
                      </div>
                      <div class="col-md-2 mb-2">
                        <label>Parcelas</label>
                        <input type="number" class="form-control" v-model="supplier.quota" min="1"
                          @keypress="preventNegative" />
                      </div>
                      <div class="col-md-2 mb-2">
                        <label>Valor</label>
                        <input type="text" class="form-control" v-model="supplier.value" v-money="moneyConfig"
                          placeholder="Valor" />
                      </div>
                      <div class="col-md-2 mb-2">
                        <label>Data</label>
                        <input type="date" class="form-control" v-model="supplier.date" min="2000-01-01"
                          max="9999-12-31" />
                      </div>
                      <div class="col-md-2 mb-2 text-right">
                        <button :class="[
                          'btn',
                          'mt-2',
                          isSupplierFormValid
                            ? 'btn-success'
                            : 'btn-secondary',
                        ]" @click="addSupplier()" :title="supplierValidationMessage || 'Clique para adicionar'
                            ">
                          <i class="fa fa-check"></i> Adicionar
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="mt-1 supplier-table-container" style="overflow-x: auto; position: relative">
                    <fieldset :disabled="dasp.status === 4">
                      <table class="table table-bordered mt-1" style="width: 100%">
                        <thead>
                          <tr class="text-center">
                            <th scope="col" style="min-width: 18%; max-width: 18%">
                              Loja
                            </th>
                            <th scope="col" style="min-width: 18%; max-width: 18%">
                              Método
                            </th>
                            <th scope="col" style="min-width: 8%; max-width: 8%">
                              Dígitos
                            </th>
                            <th scope="col" style="min-width: 8%; max-width: 8%">
                              Parcelas
                            </th>
                            <th scope="col" style="min-width: 18%; max-width: 18%">
                              Valor
                            </th>
                            <th scope="col" style="min-width: 18%; max-width: 18%">
                              Data
                            </th>
                            <th scope="col" style="min-width: 10%; max-width: 10%">
                              Ações
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(supplier, index) in supplierList" :key="index">
                            <td>
                              <input type="text" class="form-control" v-model="supplier.name" />
                            </td>
                            <td>
                              <v-select v-model="supplier.method" :options="payment" :reduce="(payment) => payment.id"
                                :label="'name'" class="supplier-method-select"></v-select>
                            </td>
                            <td>
                              <input type="text" class="form-control" v-model="supplier.last_digits" maxlength="4"
                                placeholder="Dígitos" v-if="supplier.method === 1" style="width: 80px" />
                              <span v-else class="text-muted">-</span>
                            </td>
                            <td>
                              <input type="number" class="form-control" v-model="supplier.quota" min="1"
                                @keypress="preventNegative" style="width: 70px" />
                            </td>
                            <td>
                              <input type="text" class="form-control" v-model="supplier.value" v-money="moneyConfig" />
                            </td>
                            <td>
                              <input type="date" class="form-control" v-model="supplier.date" min="2000-01-01"
                                max="9999-12-31" />
                            </td>
                            <td>
                              <button class="btn-remove ml-1" @click="removeSupplier(index)">
                                <i class="fas fa-trash" data-toggle="tooltip" title="Excluir"></i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </fieldset>
                  </div>
                </div>
              </div>

              <div class="col-md-12 my-1">
                <div :class="[
                  'dasp-card',
                  $store.state.appConfig.layout.skin === 'dark'
                    ? 'dasp-card-dark'
                    : 'dasp-card-light',
                ]">
                  <div class="dasp-card-header">
                    <i class="fas fa-file-alt text-warning" style="font-size: 22px"></i>
                    <h3 class="mb-0 text-warning dasp-card-title">Arquivos</h3>
                    <div class="dasp-card-line" style="border-color: #ffc107"></div>
                  </div>

                  <button class="mt-2 btn btn-outline-secondary btn-sm mb-1" data-toggle="collapse"
                    data-target="#collapseDocs" aria-expanded="false" aria-controls="collapseDocs">
                    <i class="fas fa-plus"></i> Adicionar arquivo
                  </button>

                  <div class="collapse" id="collapseDocs">
                    <div :class="[
                      'card card-body',
                      $store.state.appConfig.layout.skin === 'dark'
                        ? 'dasp-inner-card-dark'
                        : 'dasp-inner-card-light',
                    ]">
                      <textarea type="text" :class="[
                        'form-control',
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'dasp-input-dark'
                          : 'dasp-input-light',
                      ]" v-model="document.description" placeholder="Descreva o arquivo"></textarea>
                      <input type="file" class="form-control dasp-input mt-1" id="file" accept=".pdf,.png,.jpg,.jpeg"
                        @change="validateFile" />
                      <div v-if="selectedFileInfo" class="mt-2 p-2 bg-light rounded text-muted small">
                        <i class="fas fa-file mr-1"></i>
                        <strong>{{ selectedFileInfo.name }}</strong> -
                        {{ selectedFileInfo.size }}
                      </div>
                      <small class="text-muted mt-2">
                        Tipos aceitos: PDF, PNG, JPG, JPEG (máximo 10MB)
                      </small>
                      <div class="d-flex justify-content-end mt-3">
                        <button class="btn btn-primary" data-toggle="collapse" data-target="#collapseDocs"
                          aria-expanded="false" aria-controls="collapseDocs" @click="saveDocument()">
                          <i class="fas fa-plus"></i> Incluir Arquivo
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="mt-3" v-for="doc in docs" :key="doc.id">
                    <div :class="[
                      'card',
                      $store.state.appConfig.layout.skin === 'dark'
                        ? 'dasp-inner-card-dark'
                        : 'dasp-inner-card-light',
                    ]">
                      <div class="card-body">
                        <div class="d-flex justify-content-between align-items-start">
                          <div class="flex-grow-1">
                            <h6 :class="[
                              'mb-1',
                              $store.state.appConfig.layout.skin === 'dark'
                                ? 'dasp-label-dark'
                                : 'dasp-label-light',
                            ]">
                              {{ doc.user.name }} ({{ doc.created_at_f }})
                            </h6>
                            <p :class="[
                              'mb-2',
                              $store.state.appConfig.layout.skin === 'dark'
                                ? 'dasp-label-dark'
                                : 'dasp-label-light',
                            ]">
                              {{ doc.description }}
                            </p>
                            <a class="btn btn-secondary btn-sm" :href="doc.file_link" target="_blank">
                              <i class="fas fa-download"></i> Acessar documento
                            </a>
                          </div>
                          <div v-if="isAccessNivel8" class="ml-2">
                            <button class="btn-remove" @click="abrirModalRemocaoArquivo(doc.id)"
                              title="Excluir arquivo">
                              <i class="fas fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Modal de confirmação de exclusão de arquivo -->
                  <transition name="modal-fade" appear>
                    <div v-if="showConfirmDeleteFileModal" class="confirm-overlay">
                      <div class="confirm-card">
                        <p>Tem certeza que deseja excluir este arquivo?</p>
                        <button class="btn btn-danger btn-sm mr-2" @click="confirmarRemocaoArquivo">
                          Sim
                        </button>
                        <button class="btn btn-secondary btn-sm" @click="cancelarRemocaoArquivo">
                          Cancelar
                        </button>
                      </div>
                    </div>
                  </transition>

                  <!-- Modal de adicionar arquivo ao item -->
                  <transition name="modal-fade" appear>
                    <div v-if="productDocUpload.productId" class="confirm-overlay">
                      <div class="confirm-card" style="position: relative">
                        <button type="button" class="close" style="position: absolute; top: 10px; right: 14px"
                          aria-label="Fechar" title="Fechar" @click="cancelProductDocUpload">
                          <span aria-hidden="true">&times;</span>
                        </button>
                        <p>Adicionar arquivo ao item</p>
                        <input ref="productDocFileInput" type="file" class="form-control form-control-sm mb-3"
                          accept=".pdf,.png,.jpg,.jpeg" @change="onProductDocFileChange" />
                        <div v-if="productDocUpload.file" class="mb-3 text-left d-flex align-items-center">
                          <i class="fas fa-file mr-1"></i>
                          <a href="#" @click.prevent="viewSelectedProductDoc" class="mr-2">{{
                            productDocUpload.file.name }}</a>
                          <button type="button" class="close ml-auto" aria-label="Remover arquivo"
                            title="Remover arquivo" @click="clearSelectedProductDoc">
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <button class="btn btn-add btn-sm mr-2" :disabled="productDocUpload.uploading"
                          @click="uploadProductDoc(productDocUpload.productId)">
                          {{ productDocUpload.uploading ? "Enviando..." : "Enviar" }}
                        </button>
                        <button class="btn btn-secondary btn-sm" :disabled="productDocUpload.uploading"
                          @click="cancelProductDocUpload">
                          Cancelar
                        </button>
                      </div>
                    </div>
                  </transition>
                </div>
              </div>

              <hr />
              <!-- Interações -->
              <div class="col-md-12">
                <div :class="[
                  'dasp-card',
                  $store.state.appConfig.layout.skin === 'dark'
                    ? 'dasp-card-dark'
                    : 'dasp-card-light',
                ]">
                  <div class="dasp-card-header">
                    <i class="fas fa-comments text-info" style="font-size: 22px"></i>
                    <h3 class="mb-0 text-info dasp-card-title">Interações</h3>
                    <div class="dasp-card-line" style="border-color: #17a2b8"></div>
                  </div>

                  <div :class="[
                    'card card-body mt-4 mb-3',
                    $store.state.appConfig.layout.skin === 'dark'
                      ? 'dasp-inner-card-dark'
                      : 'dasp-inner-card-light',
                  ]">
                    <div class="row">
                      <div class="col-md-12">
                        <label :class="$store.state.appConfig.layout.skin === 'dark'
                            ? 'dasp-label-dark'
                            : 'dasp-label-light'
                          ">Nova Interação</label>
                        <ckeditor v-model="interaction.description" :editor="editor" :config="editorConfig" />
                      </div>
                      <div class="col-md-12 text-right mt-3">
                        <button class="btn btn-primary" @click="saveInteraction()">
                          <i class="fas fa-arrow-right"></i> Incluir
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Lista de interações dentro do card -->
                  <div class="mt-3 mb-3">
                    <div class="row" v-for="interact in dasp_interactions" :key="interact.id">
                      <div class="col-md-12">
                        <div class="card" :class="interact.actor == 0
                            ? user_logged != interact.user_id &&
                              interact.actor == 0
                              ? 'gray-50'
                              : 'gray-100'
                            : 'blue'
                          ">
                          <div class="card-body">
                            <h5 class="card-title" :class="user_logged != interact.user_id
                                ? 'text-right'
                                : ''
                              " style="
                                font-size: 14px;
                                font-style: italic;
                                font-weight: bold;
                              ">
                              {{ interact.user.name }} em
                              {{ interact.created_at_f }}
                            </h5>
                            <p class="card-text">
                              <span v-html="interact.description"></span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Rodapé do card -->
              <div class="col-12 mt-5">
                <div class="toolbar d-flex align-items-center flex-wrap">
                  <!-- ESQUERDA -->
                  <div class="toolbar-left d-flex align-items-center flex-wrap">
                    <button class="btn btn-warning" @click="reabrir" v-if="isAccessNivel8 && dasp.status === 4">
                      <i class="fa fa-undo"></i> Reabrir DASP
                    </button>

                    <button v-if="
                      current_manager.action === 1 &&
                      current_manager.user_id === $store.state.user.id
                    " type="button" class="btn btn-outline-success" @click="approve">
                      <i class="fas fa-check"></i> Aprovar
                    </button>

                    <button v-if="
                      current_manager.action === 1 &&
                      current_manager.user_id === $store.state.user.id
                    " type="button" class="btn btn-outline-warning" @click="cancel">
                      <i class="fas fa-ban"></i> Cancelar
                    </button>

                    <button v-if="
                      current_manager.action === 1 &&
                      current_manager.user_id === $store.state.user.id
                    " type="button" class="btn btn-outline-danger" @click="reject">
                      <i class="fas fa-times"></i> Rejeitar
                    </button>
                  </div>

                  <!-- DIREITA -->
                  <div class="toolbar-right d-flex align-items-center flex-wrap ml-auto">
                    <router-link to="/dasps" custom v-slot="{ navigate }">
                      <button type="button" class="btn btn-outline-secondary" @click="navigate">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </button>
                    </router-link>

                    <button v-if="isAccessNivel8" type="button" class="btn btn-outline-info" @click="partialSave">
                      <i class="fa fa-save"></i> Salvar Parcialmente
                    </button>

                    <!-- Botão Salvar: apenas se NÃO for status "Aguardando Compra" (3) -->
                    <button v-if="
                      [2].includes(current_manager.action) &&
                      current_manager.user_id === $store.state.user.id &&
                      dasp.status !== 3
                    " type="button" :class="[
                        'btn',
                        supplierList.length === 0
                          ? 'btn-secondary'
                          : 'btn-outline-success',
                      ]" @click="supplierList.length > 0 ? save() : null" :disabled="supplierList.length === 0" :title="supplierList.length === 0
                          ? 'Adicione pelo menos um detalhe de pagamento para salvar'
                          : ''
                        ">
                      Salvar <i class="fa fa-save"></i>
                    </button>

                    <!-- Botão Assinar: quando for status "Aguardando Compra" (3) -->
                    <button v-if="
                      dasp.status === 3 &&
                      current_manager.action === 3 &&
                      current_manager.user_id === $store.state.user.id
                    " type="button" class="btn btn-outline-success" @click="sign">
                      <i class="fas fa-signature"></i> Assinar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 d-flex justify-content-between">
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

class MyUploadAdapter {
  constructor(loader) {
    // The file loader instance to use during the upload.
    this.loader = loader;
  }

  // Starts the upload process.
  upload() {
    // Update the loader's progress.
    return this.loader.file.then(
      (file) =>
        new Promise((resolve, reject) => {
          this._initRequest();
          this._initListeners(resolve, reject, file);
          this._sendRequest(file);
        })
    );
  }

  // Aborts the upload process.
  abort() {
    // Reject the promise returned from the upload() method.
    if (this.xhr) {
      this.xhr.abort();
    }
  }

  // Initializes the XMLHttpRequest object using the URL passed to the constructor.
  _initRequest() {
    const xhr = (this.xhr = new XMLHttpRequest());

    // Note that your request may look different. It is up to you and your editor
    // integration to choose the right communication channel. This example uses
    // a POST request with JSON as a data structure but your configuration
    // could be different.
    xhr.open(
      "POST",
      "https://api.intranet.it4d.com.br/api/v1/images/upload",
      true
    );
    xhr.responseType = "json";
  }

  // Initializes XMLHttpRequest listeners.
  _initListeners(resolve, reject, file) {
    const xhr = this.xhr;
    const loader = this.loader;
    const genericErrorText = `Couldn't upload file: ${file.name}.`;

    xhr.addEventListener("error", () => reject(genericErrorText));
    xhr.addEventListener("abort", () => reject());
    xhr.addEventListener("load", () => {
      const response = xhr.response;

      // This example assumes the XHR server's "response" object will come with
      // an "error" which has its own "message" that can be passed to reject()
      // in the upload promise.
      //
      // Your integration may handle upload errors in a different way so make sure
      // it is done properly. The reject() function must be called when the upload fails.
      if (!response || response.error) {
        return reject(
          response && response.error ? response.error.message : genericErrorText
        );
      }

      // If the upload is successful, resolve the upload promise with an object containing
      // at least the "default" URL, pointing to the image on the server.
      // This URL will be used to display the image in the content. Learn more in the
      // UploadAdapter#upload documentation.
      resolve({
        default: response.url,
      });
    });

    // Upload progress when it is supported. The file loader has the #uploadTotal and #uploaded
    // properties which are used e.g. to display the upload progress bar in the editor
    // user interface.
    if (xhr.upload) {
      xhr.upload.addEventListener("progress", (evt) => {
        if (evt.lengthComputable) {
          loader.uploadTotal = evt.total;
          loader.uploaded = evt.loaded;
        }
      });
    }
  }

  // Prepares the data and sends the request.
  _sendRequest(file) {
    // Prepare the form data.
    const data = new FormData();

    data.append("upload", file);

    // Important note: This is the right place to implement security mechanisms
    // like authentication and CSRF protection. For instance, you can use
    // XMLHttpRequest.setRequestHeader() to set the request headers containing
    // the CSRF token generated earlier by your application.

    // Send the request.
    this.xhr.send(data);
  }
}

function MyUploadAdapterPlugin(editor) {
  editor.plugins.get("FileRepository").createUploadAdapter = function (loader) {
    return new MyUploadAdapter(loader);
  };
}

export default {
  name: "imageUpload",
  data() {
    return {
      deletedSuppliers: [],
      showNovoFornecedor: false,
      showConfirmModal: false,
      indexParaRemover: null,
      showConfirmDeleteFileModal: false,
      fileIdParaRemover: null,
      itensDasp: [],
      deletedItensIds: [],
      deletedProducts: [],
      document: [],
      docs: [],
      selectedFileInfo: null,
      productDocUpload: {
        productId: null,
        file: null,
        uploading: false,
      },
      moneyConfig: {
        prefix: "R$ ",
        decimal: ",",
        thousands: ".",
        precision: 2,
        masked: true,
      },

      novoProduto: {
        name: "",
        quantity_requested: "",
        budget: "",
        supplier: "",
        link: "",
      },

      today: new Date().toISOString().split("T")[0],
      text: "",
      dasp: {},
      acquisitions: [],
      billCenter: [],
      users: [],
      purchase_types: [],
      products: [],
      list: [],
      supplierList: [],
      supplier: [],
      notes: [],
      current_manager: {},
      destination: [
        {
          id: 1,
          name: "Patrimônio IT4D",
        },
        {
          id: 2,
          name: "Para o cliente previsto no contrato de fornecimento",
        },
        {
          id: 3,
          name: "Consumo",
        },
        {
          id: 4,
          name: "Revenda",
        },
      ],
      agreement: [
        {
          id: 1,
          name: "Apenas Pedido de Compra",
        },
        {
          id: 2,
          name: "Fornecimento Recorrente",
        },
      ],
      type: [
        {
          id: 1,
          name: "Serviços",
        },
        {
          id: 2,
          name: "Equipamentos e Materiais",
        },
      ],
      term: [
        {
          id: 1,
          name: "Imediato",
        },
        {
          id: 2,
          name: "Muito urgente",
        },
        {
          id: 3,
          name: "Urgente",
        },
        {
          id: 4,
          name: "Não urgente",
        },
      ],
      payment: [
        {
          id: 1,
          name: "Cartão de Crédito",
          active: true,
        },
        {
          id: 2,
          name: "Boleto",
          active: false,
        },
        {
          id: 3,
          name: "Pix",
          active: false,
        },
      ],
      // usar MAP (objeto) no lugar de array, para lookup seguro por código
      statusMap: {
        0: { name: "Rejeitado", class: "danger" },
        1: { name: "Aguardando aprovação", class: "primary" },
        2: { name: "Aguardando Cotação", class: "warning" },
        3: { name: "Aguardando Compra", class: "success" },
        4: { name: "Aprovada e Finalizada", class: "success" },
        5: { name: "Aprovada Parcialmente", class: "secondary" },
        6: { name: "Cancelado", class: "danger" },
      },
      interaction: {
        description: "",
      },
      dasp_interactions: [],
      editor: ClassicEditor,
      editorConfig: {
        width: "800px",
        height: "400px",
        extraPlugins: [MyUploadAdapterPlugin],
      },
      editorDisabledConfig: {
        toolbar: {
          items: [],
        },
      },
      user_logged: {},
      _lastUserFlowCache: null, // Cache para evitar chamadas desnecessárias do getUserFlow
    };
  },
  computed: {
    // status seguro para o badge; sempre retorna um objeto válido
    currentStatus() {
      const code =
        this.dasp && typeof this.dasp.status !== "undefined"
          ? this.dasp.status
          : null;
      // fallback para não quebrar renderização
      return (
        (code != null ? this.statusMap[code] : null) || {
          name: "—",
          class: "secondary",
        }
      );
    },

    supplierTotal() {
      let t = 0;
      this.supplierList.forEach((s) => {
        const v = String(s?.value || "")
          .replace(/[R$\s]/g, "")
          .replace(/\./g, "")
          .replace(",", ".");
        const n = parseFloat(v);
        if (!isNaN(n)) t += n;
      });
      return t;
    },

    // Calcula valor total orçado de todos os produtos
    totalBudget() {
      let total = 0;
      this.list.forEach((product) => {
        const raw = product && product.budget ? String(product.budget) : "";
        const num = parseFloat(raw.replace(/[^\d,.-]/g, "").replace(",", "."));
        if (!isNaN(num)) total += num;
      });
      return Math.round(total * 100) / 100;
    },

    // Calcula valor total pago de todos os produtos
    totalPaid() {
      let total = 0;
      this.list.forEach((product) => {
        const raw = product && product.paid ? String(product.paid) : "";
        const num = parseFloat(raw.replace(/[^\d,.-]/g, "").replace(",", "."));
        if (!isNaN(num)) total += num;
      });
      return Math.round(total * 100) / 100;
    },

    // Calcula valor total orçado de todos os produtos
    totalBudget() {
      let total = 0;
      this.list.forEach((product, index) => {
        const raw = product && product.budget ? String(product.budget) : "";
        // Remove R$ e espaços, depois remove pontos (milhares) e converte vírgula para ponto (decimal)
        const cleanValue = raw
          .replace(/R\$\s*/g, "")
          .replace(/\./g, "")
          .replace(",", ".");
        const num = parseFloat(cleanValue);
        if (!isNaN(num)) total += num;
      });
      return Math.round(total * 100) / 100;
    },

    // Calcula valor total pago de todos os produtos
    totalPaid() {
      let total = 0;
      this.list.forEach((product, index) => {
        const raw = product && product.paid ? String(product.paid) : "";
        // Remove R$ e espaços, depois remove pontos (milhares) e converte vírgula para ponto (decimal)
        const cleanValue = raw
          .replace(/R\$\s*/g, "")
          .replace(/\./g, "")
          .replace(",", ".");
        const num = parseFloat(cleanValue);
        if (!isNaN(num)) total += num;
      });
      return Math.round(total * 100) / 100;
    },

    isAccessNivel8() {
      return this.$store.state.user.perfil_id === 8;
    },

    isSupplierFormValid() {
      // Campos obrigatórios básicos
      const hasName = this.supplier?.name && this.supplier.name.trim() !== "";
      const hasMethod =
        this.supplier?.method !== null && this.supplier?.method !== undefined;
      const hasQuota = this.supplier?.quota && this.supplier.quota > 0;
      const hasDate = this.supplier?.date && this.supplier.date.trim() !== "";

      // Validação do valor - não pode ser vazio e não pode ser 0,00
      const hasValue =
        this.supplier?.value && this.supplier.value.trim() !== "";
      const valueNumber = this.supplier?.value
        ? parseFloat(
          this.supplier.value.replace(/[^\d,.-]/g, "").replace(",", ".")
        )
        : 0;
      const isValidValue = hasValue && valueNumber > 0;

      // Validação da data - deve ser uma data válida entre os anos 2000 e 3000
      let isValidDate = false;
      if (hasDate) {
        const dateObj = new Date(this.supplier.date);
        const year = dateObj.getFullYear();
        const isValidDateFormat = !isNaN(dateObj.getTime()); // Verifica se é uma data válida
        const isValidYear = year >= 2000 && year <= 3000;
        isValidDate = isValidDateFormat && isValidYear;
      }

      // Se método for cartão de crédito (id = 1), last_digits é obrigatório
      const hasLastDigits =
        this.supplier?.method === 1
          ? this.supplier?.last_digits &&
          this.supplier.last_digits.trim() !== "" &&
          this.supplier.last_digits.length === 4
          : true;

      return (
        hasName &&
        hasMethod &&
        hasQuota &&
        isValidValue &&
        isValidDate &&
        hasLastDigits
      );
    },

    supplierValidationMessage() {
      if (this.isSupplierFormValid) return "";

      const errors = [];

      // Verificações específicas
      if (!this.supplier?.name || this.supplier.name.trim() === "") {
        errors.push("Nome da loja é obrigatório");
      }

      if (!this.supplier?.method) {
        errors.push("Método de pagamento é obrigatório");
      }

      if (!this.supplier?.quota || this.supplier.quota <= 0) {
        errors.push("Número de parcelas deve ser maior que 0");
      }

      if (!this.supplier?.value || this.supplier.value.trim() === "") {
        errors.push("Valor é obrigatório");
      } else {
        const valueNumber = parseFloat(
          this.supplier.value.replace(/[^\d,.-]/g, "").replace(",", ".")
        );
        if (valueNumber <= 0) {
          errors.push("Valor deve ser maior que R$ 0,00");
        }
      }

      if (!this.supplier?.date || this.supplier.date.trim() === "") {
        errors.push("Data é obrigatória");
      } else {
        const dateObj = new Date(this.supplier.date);
        const year = dateObj.getFullYear();
        if (isNaN(dateObj.getTime())) {
          errors.push("Data inválida");
        } else if (year < 2000 || year > 3000) {
          errors.push("Ano deve estar entre 2000 e 3000");
        }
      }

      if (this.supplier?.method === 1) {
        if (
          !this.supplier?.last_digits ||
          this.supplier.last_digits.trim() === ""
        ) {
          errors.push("Últimos 4 dígitos do cartão são obrigatórios");
        } else if (this.supplier.last_digits.length !== 4) {
          errors.push("Últimos dígitos devem ter exatamente 4 números");
        }
      }

      return errors.join(", ");
    },
  },

  methods: {
    // Método para calcular o valor total orçado por produto (unitário * quantidade)
    getTotalBudgetForProduct(product) {
      const raw = String(product.budget || "");
      // Remove R$ e espaços, depois remove pontos (milhares) e converte vírgula para ponto (decimal)
      const cleanValue = raw
        .replace(/R\$\s*/g, "")
        .replace(/\./g, "")
        .replace(",", ".");
      const unit = parseFloat(cleanValue) || 0;
      const qty = Number(product.quantity_requested) || 1;

      const total = unit;

      // Formatar para moeda brasileira
      return total.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },

    reabrir() {
      const api = this.$store.state.api + "dasps/" + this.dasp.id;

      const fd = this.makeFormData();
      fd.set("status", 3);
      fd.set("_method", "PUT");

      axios
        .post(api, fd)
        .then(() => {
          this.$message(
            "Sucesso",
            "DASP voltou para 'Aguardando Compra'.",
            "success"
          );
          this.getDasp(this.dasp.id);
        })
        .catch((err) => {
          this.$message(
            null,
            err?.response?.data || "Erro ao reabrir",
            "error"
          );
        });
    },

    adicionarProduto() {
      if (!this.novoProduto.name || !this.novoProduto.quantity_requested) {
        this.$message(null, "Preencha todos os campos obrigatórios", "error");
        return false;
      }

      // Validar quantidade - não pode ser zero ou negativa
      const quantidade = Number(this.novoProduto.quantity_requested);
      if (quantidade <= 0) {
        this.$message(null, "A quantidade deve ser maior que zero", "error");
        return false;
      }

      // Validar valor orçado - não pode ser zero se preenchido
      if (this.novoProduto.budget && this.novoProduto.budget.trim() !== "") {
        const valorOrcado = parseFloat(
          this.novoProduto.budget.replace(/[^\d,.-]/g, "").replace(",", ".")
        );
        if (isNaN(valorOrcado) || valorOrcado <= 0) {
          this.$message(
            null,
            "O valor orçado deve ser maior que R$ 0,00",
            "error"
          );
          return false;
        }
      }

      this.list.push({ ...this.novoProduto, approved: false });
      this.novoProduto = {
        name: "",
        quantity_requested: "",
        budget: "",
        link: "",
      };
      return true;
    },

    abrirModalRemocao(index) {
      this.indexParaRemover = index;
      this.showConfirmModal = true;
    },
    confirmarRemocao() {
      this.removerProdutoEPartialSave();
      this.showConfirmModal = false;
      this.indexParaRemover = null;
    },
    cancelarRemocao() {
      this.showConfirmModal = false;
      this.indexParaRemover = null;
    },

    abrirModalRemocaoArquivo(fileId) {
      this.fileIdParaRemover = fileId;
      this.showConfirmDeleteFileModal = true;
    },
    productDocs(productId) {
      return this.docs.filter((doc) => doc.dasp_product_id === productId);
    },
    onProductDocFileChange(event) {
      const file = event.target.files[0];

      if (file && !this.isProductFileValid(file)) {
        event.target.value = "";
        this.productDocUpload.file = null;
        return;
      }

      this.productDocUpload.file = file || null;
    },
    isProductFileValid(file) {
      const allowedTypes = [
        "application/pdf",
        "image/png",
        "image/jpeg",
        "image/jpg",
      ];
      const allowedExtensions = [".pdf", ".png", ".jpg", ".jpeg"];

      const fileExtension = file.name
        .toLowerCase()
        .substring(file.name.lastIndexOf("."));

      if (
        !allowedTypes.includes(file.type) &&
        !allowedExtensions.includes(fileExtension)
      ) {
        this.$message(
          null,
          "Tipo de arquivo não suportado. Use apenas: PDF, PNG, JPG ou JPEG",
          "error"
        );
        return false;
      }

      const maxSize = 10 * 1024 * 1024;
      if (file.size > maxSize) {
        this.$message(
          null,
          "Arquivo muito grande. O tamanho máximo é 10MB",
          "error"
        );
        return false;
      }

      return true;
    },
    uploadProductDoc(productId) {
      const self = this;

      if (self.productDocUpload.uploading) {
        return;
      }

      if (!self.productDocUpload.file) {
        self.$message(null, "Selecione um arquivo para enviar", "error");
        return;
      }

      self.productDocUpload.uploading = true;

      let api = self.$store.state.api + "dasp_docs";
      let fd = new FormData();
      fd.append("description", self.productDocUpload.file.name);
      fd.append("dasp_id", self.dasp.id);
      fd.append("dasp_product_id", productId);
      fd.append("user_id", self.$store.state.user.id);
      fd.append("file", self.productDocUpload.file);

      axios
        .post(api, fd)
        .then(() => {
          self.$message("Sucesso", "Arquivo enviado com sucesso", "success");
          self.getDaspDocs(self.dasp.id);
          self.cancelProductDocUpload();
        })
        .catch((error) => {
          let errorMessage = "Falha ao enviar o arquivo";

          if (error.response && error.response.data) {
            if (typeof error.response.data === "string") {
              errorMessage = error.response.data;
            } else if (error.response.data.message) {
              errorMessage = error.response.data.message;
            }
          }

          self.$message(null, errorMessage, "error");
          self.productDocUpload.uploading = false;
        });
    },
    cancelProductDocUpload() {
      this.productDocUpload = { productId: null, file: null, uploading: false };
    },
    viewSelectedProductDoc() {
      window.open(URL.createObjectURL(this.productDocUpload.file), "_blank");
    },
    clearSelectedProductDoc() {
      this.productDocUpload.file = null;
      if (this.$refs.productDocFileInput) {
        this.$refs.productDocFileInput.value = "";
      }
    },
    confirmarRemocaoArquivo() {
      this.deleteDocument(this.fileIdParaRemover);
      this.showConfirmDeleteFileModal = false;
      this.fileIdParaRemover = null;
    },
    cancelarRemocaoArquivo() {
      this.showConfirmDeleteFileModal = false;
      this.fileIdParaRemover = null;
    },
    removerProduto(index) {
      if (this.list.length > 1) {
        const item = this.list[index];
        if (item.id) {
          this.deletedProducts.push(item.id);
        }
        this.list.splice(index, 1);
      } else {
        this.$message(null, "A DASP deve ter pelo menos 1 item.", "error");
      }
    },

    adicionarProdutoEPartialSave() {
      // Só faz o save parcial se a adição for bem-sucedida
      if (this.adicionarProduto()) {
        this.partialSave();
      }
    },

    removerProdutoEPartialSave() {
      this.removerProduto(this.indexParaRemover);
      this.partialSave();
    },

    validateApprovedItems() {
      const self = this;
      const approvedItems = self.list.filter((item) => item.approved);

      if (approvedItems.length === 0) {
        return true; // Se não há itens aprovados, não precisa validar
      }

      // Validação eliminatória - mostrar apenas o primeiro erro encontrado
      for (let index = 0; index < approvedItems.length; index++) {
        const item = approvedItems[index];
        const itemNumber = index + 1;
        const itemName = item.name
          ? ` (${item.name.substring(0, 30)}${item.name.length > 30 ? "..." : ""
          })`
          : "";

        // 1. Validar quantidade atendida (primeira prioridade)
        if (!item.quantity_delivered || item.quantity_delivered <= 0) {
          self.$message(
            null,
            `Item ${itemNumber}${itemName}: Quantidade atendida deve ser maior que zero`,
            "error"
          );
          return false;
        }

        // 2. Validar fornecedor (segunda prioridade)
        if (!item.supplier || item.supplier.trim() === "") {
          self.$message(
            null,
            `Item ${itemNumber}${itemName}: Fornecedor é obrigatório`,
            "error"
          );
          return false;
        }

        // 3. Validar prazo (terceira prioridade)
        if (!item.term) {
          self.$message(
            null,
            `Item ${itemNumber}${itemName}: Prazo (data) é obrigatório`,
            "error"
          );
          return false;
        } else {
          const termDate = new Date(item.term);
          const today = new Date();
          const oneMonthAgo = new Date();
          oneMonthAgo.setMonth(today.getMonth() - 1);

          if (termDate < oneMonthAgo) {
            self.$message(
              null,
              `Item ${itemNumber}${itemName}: Prazo não pode ser superior a 1 mês no passado`,
              "error"
            );
            return false;
          }
        }

        // 4. Validar valor pago (última prioridade)
        if (!item.paid || item.paid.trim() === "" || item.paid === "R$ 0,00") {
          self.$message(
            null,
            `Item ${itemNumber}${itemName}: Valor pago deve ser maior que R$ 0,00`,
            "error"
          );
          return false;
        }
      }

      return true;
    },

    validateProductTerms() {
      // Validar prazos de todos os produtos com prazo preenchido
      for (let i = 0; i < this.list.length; i++) {
        const product = this.list[i];

        if (product.term) {
          const termDate = new Date(product.term);
          const today = new Date();
          const oneMonthAgo = new Date();
          oneMonthAgo.setMonth(today.getMonth() - 1);

          if (termDate < oneMonthAgo) {
            this.$message(
              null,
              `O Prazo digitado no Item ${i + 1
              } é inválido, por favor digite uma data válida`,
              "error"
            );
            return false;
          }
        }
      }
      return true;
    },

    validateSupplierList() {
      // Validar todos os fornecedores na lista
      for (let i = 0; i < this.supplierList.length; i++) {
        const supplier = this.supplierList[i];

        // Validar valor - não pode ser 0,00
        if (supplier.value) {
          const valueNumber = parseFloat(
            supplier.value.replace(/[^\d,.-]/g, "").replace(",", ".")
          );
          if (isNaN(valueNumber) || valueNumber <= 0) {
            this.$message(
              null,
              `Fornecedor ${i + 1}: Valor precisa ser maior que R$ 0,00`,
              "error"
            );
            return false;
          }
        }

        // Validar data - ano deve estar entre 2000-3000
        if (supplier.date) {
          const dateObj = new Date(supplier.date);
          const year = dateObj.getFullYear();
          if (isNaN(dateObj.getTime()) || year < 2000 || year > 3000) {
            this.$message(
              null,
              `Fornecedor ${i + 1}: Digite um valor válido para a data`,
              "error"
            );
            return false;
          }
        }
      }
      return true;
    },

    partialSave: function () {
      const self = this;

      // Validar fornecedores antes de salvar parcialmente
      if (!this.validateSupplierList()) {
        return; // Para a execução se houver erro
      }

      // Validar prazos dos produtos antes de salvar
      if (!this.validateProductTerms()) {
        return; // Para a execução se houver erro
      }

      let api = self.$store.state.api + "dasps/" + self.dasp.id;

      const listSemAprovado = self.list.map((item) => ({
        ...item,
        approved: item.approved ?? 0,
        quantity_delivered: item.quantity_delivered || null,
        budget: item.budget || null,
        paid: item.paid || null,
      }));

      let fd = new FormData();

      fd.append("budget", self.dasp.budget ? self.dasp.budget : "");
      fd.append("paid", self.dasp.paid ? self.dasp.paid : "");
      fd.append(
        "bill_center_id",
        self.dasp.bill_center_id ? self.dasp.bill_center_id : ""
      );
      fd.append(
        "destination",
        self.dasp.destination ? self.dasp.destination : ""
      );
      fd.append("agreement", self.dasp.agreement ? self.dasp.agreement : "");
      fd.append(
        "collaborator",
        self.dasp.collaborator ? self.dasp.collaborator : ""
      );
      fd.append("term", self.dasp.term ? self.dasp.term : "");
      fd.append("type", self.dasp.type ? self.dasp.type : "");

      fd.append("list", JSON.stringify(listSemAprovado));
      fd.append("supplierList", JSON.stringify(self.supplierList));
      fd.append("deletedProducts", JSON.stringify(self.deletedProducts));
      fd.append("deletedSuppliers", JSON.stringify(self.deletedSuppliers));

      fd.append("_method", "PUT");


      axios
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Salvo parcialmente",
            "Informações atualizadas sem finalizar a ocorrência.",
            "success"
          );
          self.deletedProducts = [];
          self.deletedSuppliers = [];
          // RELOAD dos dados!
          self.getDasp(self.dasp.id);
          self.getDaspProducts(self.dasp.id);
          self.getSuppliers(self.dasp.id);
          self.getNotes(self.dasp.id);
          self.getDaspDocs(self.dasp.id);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    approveAllProducts() {
      this.list.forEach((product) => {
        product.approved = true;
      });
    },
    makeFormDataDocument: function () {
      const self = this;

      let fd = new FormData();
      let file = document.getElementById("file");

      fd.append("description", self.document.description);
      fd.append("dasp_id", self.dasp.id);
      fd.append("user_id", self.$store.state.user.id);

      fd.append("file", file.files[0] ? file.files[0] : "");
      fd.append("_method", "POST");

      return fd;
    },
    validateFile: function () {
      const fileInput = document.getElementById("file");
      const file = fileInput.files[0];

      if (!file) {
        this.selectedFileInfo = null;
        return;
      }

      // Capturar informações do arquivo
      const fileName = file.name;
      const fileSize = this.formatFileSize(file.size);

      this.selectedFileInfo = {
        name: fileName,
        size: fileSize,
      };

      // Validar tipo de arquivo
      const allowedTypes = [
        "application/pdf",
        "image/png",
        "image/jpeg",
        "image/jpg",
      ];
      const allowedExtensions = [".pdf", ".png", ".jpg", ".jpeg"];

      const fileExtension = file.name
        .toLowerCase()
        .substring(file.name.lastIndexOf("."));

      if (
        !allowedTypes.includes(file.type) &&
        !allowedExtensions.includes(fileExtension)
      ) {
        this.$message(
          null,
          "Tipo de arquivo não suportado. Use apenas: PDF, PNG, JPG ou JPEG",
          "error"
        );
        fileInput.value = "";
        this.selectedFileInfo = null;
        return false;
      }

      // Validar tamanho (10MB = 10 * 1024 * 1024 bytes)
      const maxSize = 10 * 1024 * 1024;
      if (file.size > maxSize) {
        this.$message(
          null,
          "Arquivo muito grande. O tamanho máximo é 10MB",
          "error"
        );
        fileInput.value = "";
        this.selectedFileInfo = null;
        return false;
      }

      return true;
    },

    formatFileSize: function (bytes) {
      if (bytes === 0) return "0 Bytes";

      const k = 1024;
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    },

    saveDocument: function () {
      const self = this;

      // Validar se descrição foi preenchida
      if (
        !self.document.description ||
        self.document.description.trim() === ""
      ) {
        this.$message(null, "A descrição do arquivo é obrigatória", "error");
        return;
      }

      // Validar se arquivo foi selecionado
      const fileInput = document.getElementById("file");
      if (!fileInput.files[0]) {
        this.$message(null, "Selecione um arquivo para enviar", "error");
        return;
      }

      // Validar arquivo novamente antes de enviar
      if (!this.validateFile()) {
        return;
      }

      let api = self.$store.state.api + "dasp_docs";
      let fd = self.makeFormDataDocument();

      axios
        .post(api, fd)
        .then((response) => {
          self.$message("Sucesso", `Arquivo enviado com sucesso`, "success");

          self.getDaspDocs(self.dasp.id);
          self.document.description = "";
          document.getElementById("file").value = "";
          self.selectedFileInfo = null;
        })
        .catch((error) => {
          let errorMessage = "Falha ao enviar o arquivo";

          if (error.response && error.response.data) {
            if (typeof error.response.data === "string") {
              errorMessage = error.response.data;
            } else if (error.response.data.message) {
              errorMessage = error.response.data.message;
            }
          }

          self.$message(null, errorMessage, "error");
          self.selectedFileInfo = null;
        });
    },

    deleteDocument: function (docId) {
      const self = this;

      const api = self.$store.state.api + "dasp_docs/" + docId;

      axios
        .delete(api)
        .then((response) => {
          self.$message("Sucesso", "Arquivo excluído com sucesso", "success");

          // Atualizar lista de documentos
          self.getDaspDocs(self.dasp.id);
        })
        .catch((error) => {
          let errorMessage = "Falha ao excluir o arquivo";

          if (error.response && error.response.data) {
            if (typeof error.response.data === "string") {
              errorMessage = error.response.data;
            } else if (error.response.data.message) {
              errorMessage = error.response.data.message;
            }
          }

          self.$message(null, errorMessage, "error");
        });
    },

    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      fd.append("budget", self.dasp.budget ? self.dasp.budget : "");
      fd.append("paid", self.dasp.paid ? self.dasp.paid : "");
      fd.append(
        "bill_center_id",
        self.dasp.bill_center_id ? self.dasp.bill_center_id : ""
      );
      fd.append(
        "destination",
        self.dasp.destination ? self.dasp.destination : ""
      );
      fd.append("agreement", self.dasp.agreement ? self.dasp.agreement : "");
      fd.append(
        "collaborator",
        self.dasp.collaborator ? self.dasp.collaborator : ""
      );
      fd.append("term", self.dasp.term ? self.dasp.term : "");
      fd.append("type", self.dasp.type ? self.dasp.type : "");
      fd.append("status", self.dasp.status ? self.dasp.status : "");

      // Sanitizar dados da lista antes de enviar
      const sanitizedList = self.list.map((item) => ({
        ...item,
        quantity_delivered: item.quantity_delivered || null,
        budget: item.budget || null,
        paid: item.paid || null,
      }));

      fd.append("list", JSON.stringify(sanitizedList));
      fd.append("supplierList", JSON.stringify(self.supplierList));
      fd.append("deletedProducts", JSON.stringify(this.deletedProducts));
      fd.append("deletedSuppliers", JSON.stringify(this.deletedSuppliers));

      fd.append("_method", "PUT");

      return fd;
    },
    save: function () {
      const self = this;

      // Validar fornecedores antes de salvar
      if (!this.validateSupplierList()) {
        return; // Para a execução se houver erro
      }

      // Validar prazos dos produtos antes de salvar
      if (!this.validateProductTerms()) {
        return; // Para a execução se houver erro
      }

      let api = self.$store.state.api + "dasps";

      api += "/" + self.dasp.id;

      if (!self.list.length) {
        this.$message(
          null,
          "Você precisa adicionar produtos/serviços",
          "error"
        );
        return;
      }

      // Validar se todos os campos obrigatórios dos itens aprovados estão preenchidos
      if (!self.validateApprovedItems()) {
        return; // Interrompe o salvamento se houver campos obrigatórios não preenchidos
      }

      let fd = self.makeFormData();


      axios
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          self.deletedProducts = [];
          this.$router.push("/dasps");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getDasp: function (id) {
      const self = this;
      const api =
        self.$store.state.api + "dasps/" + id + "?with[]=bill_center_dasp";

      axios
        .get(api)
        .then((response) => {
          if (!response.data.data.length) {
            return this.$router.push("/dasps");
          }
          const rawDasp = response.data.data[0];
          const bill_center_id = (rawDasp.bill_center_dasp || []).map(
            (bc) => bc.bill_center_id
          );
          self.dasp = { ...rawDasp, bill_center_id };

          self.getUserFlow(id);
          self.getInteractions();
          self.user_logged = self.$store.state.user.id;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getInteractions() {
      const self = this;
      const api =
        self.$store.state.api +
        "dasp_interactions/?dasp_id=" +
        self.dasp.id +
        "&orderByDesc=id&with[]=user";

      axios
        .get(api)
        .then((response) => {
          self.dasp_interactions = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    saveInteraction() {
      const self = this;
      const api = self.$store.state.api + "dasp_interactions/";

      self.interaction.dasp_id = self.dasp.id;
      self.interaction.user_id = self.$store.state.user.id;
      self.$loading(true);

      axios
        .post(api, self.interaction)
        .then(() => {
          self.$message("Sucesso", `Interação salva com sucesso`, "success");

          self.interaction.description = "";
          self.getDasp(self.dasp.id);
          self.$loading(false);
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },

    getAcquisitions: function () {
      const self = this;
      const api = self.$store.state.api + "acquisitions?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.acquisitions = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getDaspDocs: function (id) {
      const self = this;
      const api = self.$store.state.api + "dasp_docs?with[]=user&dasp_id=" + id;

      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.docs = response.data.data;

          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getDaspProducts: function (id) {
      const self = this;
      const api = self.$store.state.api + "dasp_products?dasp_id=" + id;

      axios
        .get(api)
        .then((response) => {
          self.list = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getSuppliers: function (id) {
      const self = this;
      const api = self.$store.state.api + "dasp_suppliers?dasp_id=" + id;

      axios
        .get(api)
        .then((response) => {
          self.supplierList = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getBillCenter: function () {
      const self = this;
      const api = self.$store.state.api + "bill_centers?paginated=false";

      return axios
        .get(api)
        .then((response) => {
          self.billCenter = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getUsers: function () {
      const self = this;
      const api = self.$store.state.api + "users?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.users = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getUserFlow: function () {
      const self = this;
      let action = self.dasp.status === 5 ? 2 : self.dasp.status;

      // Evitar chamadas desnecessárias com cache
      const cacheKey = `${self.dasp.bill_center_id}_${self.$store.state.user.id}_${action}`;
      if (this._lastUserFlowCache === cacheKey) {
        return; // Já foi executado com os mesmos parâmetros
      }
      this._lastUserFlowCache = cacheKey;

      // Verificar se os dados necessários estão disponíveis
      if (
        !self.dasp.bill_center_id ||
        !self.$store.state.user.id ||
        action == null
      ) {
        return;
      }

      const api =
        self.$store.state.api +
        "bill_center_flows?bill_center_id=" +
        self.dasp.bill_center_id +
        "&user_id=" +
        self.$store.state.user.id +
        "&action=" +
        action;

      axios
        .get(api)
        .then((response) => {
          self.current_manager = response.data.data[0] || {};
        })
        .catch((error) => {
          self.current_manager = {};
          self.$message(null, error.response.data, "error");
        });
    },

    formatarData(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    approve: function () {
      const self = this;

      const api =
        self.$store.state.api +
        "dasps_approvement/" +
        self.dasp.id +
        "?approve=1&bill_center_id=" +
        self.dasp.bill_center_id;

      const hasAnyApproved = self.list.some((product) => product.approved);

      if (!hasAnyApproved) {
        self.$message(
          null,
          "É necessário aprovar pelo menos um item.",
          "error"
        );
        return;
      }

      const payload = {
        approved_products: self.list,
      };

      axios
        .post(api, payload)
        .then(() => {
          self.$router.push("/dasps");
        })
        .catch((error) => {
          self.$message(
            null,
            error.response?.data || "Erro ao aprovar",
            "error"
          );
        });
    },

    reject: function () {
      const self = this;
      const api =
        self.$store.state.api +
        "dasps_approvement/" +
        self.dasp.id +
        "?approve=0&bill_center_id=" +
        self.dasp.bill_center_id;

      axios
        .post(api)
        .then(() => {
          self.$router.push("/dasps");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    cancel: function () {
      const self = this;
      const api =
        self.$store.state.api +
        "dasps_cancel/" +
        self.dasp.id +
        "?approve=6&bill_center_id=" +
        self.dasp.bill_center_id;

      axios
        .post(api)
        .then(() => {
          self.$router.push("/dasps");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    sign: function () {
      const self = this;

      // Validar fornecedores antes de assinar
      if (!this.validateSupplierList()) {
        return; // Para a execução se houver erro
      }

      // Validar prazos dos produtos antes de assinar
      if (!this.validateProductTerms()) {
        return; // Para a execução se houver erro
      }

      // Validar se todos os campos obrigatórios dos itens aprovados estão preenchidos
      if (!self.validateApprovedItems()) {
        return; // Interrompe a assinatura se houver campos obrigatórios não preenchidos
      }

      // Primeiro salvar parcialmente, depois assinar
      self
        .partialSaveBeforeSign()
        .then(() => {
          // Após salvar com sucesso, fazer a assinatura
          const api = self.$store.state.api + "dasps_sign/" + self.dasp.id;

          return axios.post(api);
        })
        .then(() => {
          self.$router.push("/dasps");
        })
        .catch((error) => {
          self.$message(
            null,
            error.response?.data || "Erro ao salvar/assinar",
            "error"
          );
        });
    },

    // Função para salvar parcialmente antes de assinar (versão Promise)
    partialSaveBeforeSign() {
      const self = this;

      // Validar fornecedores antes de salvar parcialmente
      if (!this.validateSupplierList()) {
        return Promise.reject(new Error("Validação de fornecedores falhou"));
      }

      // Validar prazos dos produtos antes de salvar
      if (!this.validateProductTerms()) {
        return Promise.reject(new Error("Validação de prazos falhou"));
      }

      let api = self.$store.state.api + "dasps/" + self.dasp.id;

      const listSemAprovado = self.list.map((item) => ({
        ...item,
        approved: item.approved ?? 0,
        quantity_delivered: item.quantity_delivered || null,
        budget: item.budget || null,
        paid: item.paid || null,
      }));

      let fd = new FormData();

      fd.append("budget", self.dasp.budget ? self.dasp.budget : "");
      fd.append("paid", self.dasp.paid ? self.dasp.paid : "");
      fd.append(
        "bill_center_id",
        self.dasp.bill_center_id ? self.dasp.bill_center_id : ""
      );
      fd.append(
        "destination",
        self.dasp.destination ? self.dasp.destination : ""
      );
      fd.append("agreement", self.dasp.agreement ? self.dasp.agreement : "");
      fd.append(
        "collaborator",
        self.dasp.collaborator ? self.dasp.collaborator : ""
      );
      fd.append("term", self.dasp.term ? self.dasp.term : "");
      fd.append("type", self.dasp.type ? self.dasp.type : "");

      fd.append("list", JSON.stringify(listSemAprovado));
      fd.append("supplierList", JSON.stringify(self.supplierList));
      fd.append("deletedProducts", JSON.stringify(self.deletedProducts));
      fd.append("deletedSuppliers", JSON.stringify(self.deletedSuppliers));

      fd.append("_method", "PUT");

      return axios.post(api, fd).then((response) => {
        // Limpar arrays de deletados após salvar
        self.deletedProducts = [];
        self.deletedSuppliers = [];
        return response;
      });
    },
    getNotes: function (id) {
      const self = this;
      const api =
        self.$store.state.api + "dasp_notes?with[]=user&dasp_id=" + id;

      axios
        .get(api)
        .then((response) => {
          self.notes = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    addNote: function () {
      const self = this;
      const api = self.$store.state.api + "dasp_notes";

      let fd = self.notesFD();

      self.text = "";

      axios
        .post(api, fd)
        .then(() => {
          self.getNotes(self.dasp.id);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    notesFD: function () {
      const self = this;
      let fd = new FormData();

      fd.append("user_id", self.$store.state.user.id);
      fd.append("dasp_id", self.dasp.id ? self.dasp.id : "");
      fd.append("text", self.text ? self.text : "");

      return fd;
    },
    preventNegative: function (event) {
      // Impede caracteres inválidos em campos numéricos: -, +, e, E
      if (
        event.key === "-" ||
        event.key === "+" ||
        event.key === "e" ||
        event.key === "E"
      ) {
        event.preventDefault();
      }
    },
    preventInvalidInput: function (event) {
      // Impede caracteres inválidos em campos numéricos: -, +, e, E
      if (
        event.key === "-" ||
        event.key === "+" ||
        event.key === "e" ||
        event.key === "E"
      ) {
        event.preventDefault();
      }
    },
    onInlineEdit: function (updateTotals = false) {
      // Método para lidar com edições inline na tabela de produtos
      // Totais agora são calculados automaticamente via computed
      // Não precisa mais recalcular manualmente
    },

    updatePaidFromSuppliers() {
      let total = 0;
      this.supplierList.forEach((supplier) => {
        if (supplier.value) {
          const valor = parseFloat(
            supplier.value
              .replace("R$", "")
              .replace(/\./g, "")
              .replace(",", ".")
              .trim()
          );
          if (!isNaN(valor)) total += valor;
        }
      });

      // Atualiza o paid do DASP
      this.dasp.paid = total;

      // Atualiza o paid de cada produto individualmente
      this.list.forEach((product) => {
        product.paid =
          "R$ " + total.toLocaleString("pt-BR", { minimumFractionDigits: 2 });
      });
    },

    addSupplier() {
      // Verificações em ordem de prioridade com mensagens específicas

      // 1. Verificar se todos os campos básicos estão preenchidos
      if (!this.supplier?.name || this.supplier.name.trim() === "") {
        this.$message(null, "Nome da loja é obrigatório", "error");
        return;
      }

      if (!this.supplier?.method) {
        this.$message(null, "Método de pagamento é obrigatório", "error");
        return;
      }

      // 2. Verificar VALOR - mensagem específica para valor = 0
      if (!this.supplier?.value || this.supplier.value.trim() === "") {
        this.$message(null, "Valor é obrigatório", "error");
        return;
      }

      const valueNumber = parseFloat(
        this.supplier.value.replace(/[^\d,.-]/g, "").replace(",", ".")
      );
      if (isNaN(valueNumber) || valueNumber <= 0) {
        this.$message(null, " 'Valor' precisa ser maior que R$ 0,00", "error");
        return;
      }

      // 3. Verificar DATA - mensagem específica para ano inválido
      if (!this.supplier?.date || this.supplier.date.trim() === "") {
        this.$message(null, "Data é obrigatória", "error");
        return;
      }

      const dateObj = new Date(this.supplier.date);
      const year = dateObj.getFullYear();
      if (isNaN(dateObj.getTime()) || year < 2000 || year > 3000) {
        this.$message(null, "Digite um valor válido para a data", "error");
        return;
      }

      // 4. Verificar parcelas
      if (!this.supplier?.quota || this.supplier.quota <= 0) {
        this.$message(null, "Número de parcelas deve ser maior que 0", "error");
        return;
      }

      // 5. Verificar dígitos do cartão se necessário
      if (this.supplier.method === 1) {
        if (
          !this.supplier?.last_digits ||
          this.supplier.last_digits.trim() === ""
        ) {
          this.$message(
            null,
            "Últimos 4 dígitos do cartão são obrigatórios",
            "error"
          );
          return;
        }
        if (this.supplier.last_digits.length !== 4) {
          this.$message(
            null,
            "Últimos dígitos devem ter exatamente 4 números",
            "error"
          );
          return;
        }
      }

      // Se chegou até aqui, todos os campos estão válidos - adicionar o supplier

      const newEntry = {
        name: this.supplier?.name || "",
        method: this.supplier?.method ?? null,
        last_digits: this.supplier?.last_digits || "",
        quota: this.supplier?.quota ? parseInt(this.supplier.quota) : null,
        value: this.supplier?.value || "",
        date: this.supplier?.date || "",
      };

      this.supplierList.push(newEntry);

      this.supplier = {
        name: "",
        method: null,
        last_digits: "",
        quota: null,
        value: "",
        date: "",
      };

      // Salvar parcialmente automaticamente após adicionar
      this.partialSave();
    },

    removeSupplier(index) {
      const supplier = this.supplierList[index];
      if (supplier?.id) {
        this.deletedSuppliers.push(supplier.id);
      }

      this.supplierList.splice(index, 1);

      // Salvar parcialmente automaticamente após remover
      this.partialSave();
    },

    formatBRL(n) {
      return (
        "R$ " +
        Number(n || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2 })
      );
    },
    getPurchaseTypes: function () {
      const self = this;
      const api = self.$store.state.api + "purchase_types?paginated=false";

      return axios
        .get(api)
        .then((response) => {
          self.purchase_types = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    // Carregar purchase_types primeiro, depois outros dados
    self.getPurchaseTypes().then(() => {
      self.getBillCenter().then(() => {
        if (id) {
          self.getDasp(id);
          self.getNotes(id);
          self.getDaspProducts(id);
          self.getDaspDocs(id);
          self.getSuppliers(id);
        }
      });
    });

    self.getUsers();
    self.getAcquisitions();

    setTimeout(() => {
      console.clear();
    }, 1500);
  },

  components: {
    BaseCrud,
    vSelect,
  },
};
</script>

<style scoped>
.toolbar {
  gap: 8px;
}

/* espaço entre grupos quando quebrar linha */
.toolbar-left,
.toolbar-right {
  gap: 8px;
  /* espaço entre botões de cada grupo */
}

.btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

/* garanta que .btn-back e .btn-add não tenham floats nem width 100% */
.btn-back,
.btn-add {
  float: none;
  width: auto;
}

.confirm-overlay {
  position: fixed;
  inset: 0;

  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9998;
}

.confirm-card {
  position: relative;
  z-index: 9999;
  background: #fff;
  color: #1a1a1a;
  padding: 24px;
  border-radius: 12px;
  min-width: 320px;
  text-align: center;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5);
}

.tabela-leitura {
  position: relative;
  z-index: 1;
}

/* Larguras específicas para cada coluna da tabela */
.tabela-leitura th:nth-child(1),
.tabela-leitura td:nth-child(1) {
  width: 200px;
  min-width: 200px;
  max-width: 300px;
}

.tabela-leitura th:nth-child(2),
.tabela-leitura td:nth-child(2) {
  width: 180px;
  min-width: 180px;
  max-width: 250px;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tabela-leitura th:nth-child(3),
.tabela-leitura td:nth-child(3) {
  width: 140px;
  min-width: 140px;
}

.tabela-leitura th:nth-child(4),
.tabela-leitura td:nth-child(4) {
  width: 150px;
  min-width: 150px;
}

.tabela-leitura th:nth-child(5),
.tabela-leitura td:nth-child(5) {
  width: 120px;
  min-width: 120px;
}

.tabela-leitura th:nth-child(6),
.tabela-leitura td:nth-child(6) {
  width: 160px;
  min-width: 160px;
}

.tabela-leitura th:nth-child(7),
.tabela-leitura td:nth-child(7) {
  width: 100px;
  min-width: 100px;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.modal-confirm {
  background: #fff;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 0 20px #2223;
  min-width: 300px;
  text-align: center;
}

.modal-confirm button {
  margin: 0 10px;
  padding: 6px 18px;
  border: none;
  border-radius: 4px;
}

.btn-remove {
  background: transparent;
  border: 1px solid #ef4444;
  border-radius: 5px;
  width: 28px;
  height: 28px;
  padding: 0;
  align-items: center;
  justify-content: center;
  color: #ef4444;
  transition: border-color 0.2s;
}

.btn-remove:hover,
.btn-remove:focus {
  border-color: #b91c1c;
  background-color: #ff040473;
}

.btn-remove:disabled,
.btn-remove[disabled] {
  pointer-events: none !important;
  background: #e4e4e4 !important;
  border-color: #ccc !important;
  color: #bbb !important;
  opacity: 0.6 !important;
}

.btn-remove:disabled:hover,
.btn-remove[disabled]:hover {
  background: #e4e4e4 !important;
  border-color: #ccc !important;
  color: #bbb !important;
  opacity: 0.6 !important;
  cursor: not-allowed !important;
}

.btn-attach {
  background: transparent;
  border: 1px solid #6c757d;
  border-radius: 5px;
  width: 28px;
  height: 28px;
  padding: 0;
  align-items: center;
  justify-content: center;
  color: #6c757d;
  transition: border-color 0.2s;
}

.btn-attach:hover,
.btn-attach:focus {
  border-color: #495057;
  background-color: #6c757d1a;
}

.btn-attach:disabled,
.btn-attach[disabled] {
  pointer-events: none !important;
  background: #e4e4e4 !important;
  border-color: #ccc !important;
  color: #bbb !important;
  opacity: 0.6 !important;
}

input[type="checkbox"]:disabled {
  pointer-events: none !important;
  opacity: 0.6 !important;
  cursor: not-allowed !important;
  accent-color: #ccc !important;
}

.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}

.notification-badge {
  position: absolute;
  top: 1px;
  right: 8px;
  background-color: red;
  color: white;
  border-radius: 50%;
  padding: 0.2em 0.5em;
  font-size: 0.75em;
  font-weight: bold;
  min-width: 1em;
  text-align: center;
  line-height: 1;
}

/* Estilo para botão de salvar desabilitado */
.btn-secondary:disabled {
  background-color: #6c757d !important;
  border-color: #6c757d !important;
  color: #fff !important;
  opacity: 0.6 !important;
  cursor: not-allowed !important;
  pointer-events: none !important;
}

.btn-secondary:disabled:hover {
  background-color: #6c757d !important;
  border-color: #6c757d !important;
}

/* CSS para corrigir dropdown do select na tabela de suppliers */
.supplier-table-container {
  overflow: visible !important;
}

.supplier-method-select .vs__dropdown-menu {
  z-index: 9999 !important;
}

.table {
  overflow: visible !important;
  border-radius: 12px;
  overflow: hidden;
}

.table td {
  overflow: visible !important;
}

/* Arredondar especificamente as tabelas com bordas */
.table-bordered {
  border-radius: 12px !important;
  overflow: hidden !important;
  border: 1px solid #dee2e6 !important;
}

/* Tabelas responsivas ao tema */
.dark-layout .table-bordered {
  background-color: #283046;
  border-color: #404656 !important;
}

.dark-layout .table-bordered th,
.dark-layout .table-bordered td {
  background-color: #283046;
  border-color: #404656 !important;
  color: #d0d2d6;
}

/* Light mode - tabela mais clara que o fundo do card */
body:not(.dark-layout) .table-bordered {
  background-color: #ffffff;
  border-color: #e9ecef !important;
}

body:not(.dark-layout) .table-bordered th,
body:not(.dark-layout) .table-bordered td {
  background-color: #ffffff;
  border-color: #e9ecef !important;
  color: #495057;
}

/* Manter cantos arredondados nas células das extremidades */
.table-bordered thead tr:first-child th:first-child {
  border-top-left-radius: 11px !important;
}

.table-bordered thead tr:first-child th:last-child {
  border-top-right-radius: 11px !important;
}

.table-bordered tbody tr:last-child td:first-child {
  border-bottom-left-radius: 11px !important;
}

.table-bordered tbody tr:last-child td:last-child {
  border-bottom-right-radius: 11px !important;
}

/* Cards - Classes separadas para dark e light */
.dasp-card {
  border-radius: 12px;
  padding: 24px 18px;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.dasp-card-dark {
  background: #191e2e;
  border: 1px solid #4a5568;
}

.dasp-card-light {
  background: #f8f8fa;
  border: 1px solid #e2e6ea;
}

.dasp-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;
}

.dasp-card-title {
  font-weight: 700;
}

.dasp-card-line {
  flex: 1;
  border-bottom: 4px solid;
  margin-left: 16px;
  opacity: 0.6;
}

.dasp-card-line-primary {
  border-color: #007bff;
}

/* Labels */
.dasp-label-dark {
  color: #e2e8f0;
  font-weight: 500;
  margin-bottom: 0.5rem;
  display: block;
}

.dasp-label-light {
  color: #2d3748;
  font-weight: 500;
  margin-bottom: 0.5rem;
  display: block;
}

/* Inputs */
.dasp-input-dark {
  background: #2d3748;
  border: 1px solid #4a5568;
  color: #e2e8f0;
}

.dasp-input-light {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  color: #2d3748;
}

/* v-select Dark */
.dasp-select-dark .vs__dropdown-toggle {
  background: #2d3748;
  border: 1px solid #4a5568;
}

.dasp-select-dark .vs__selected {
  color: #e2e8f0;
}

.dasp-select-dark .vs__search::placeholder {
  color: #a0aec0;
}

.dasp-select-dark .vs__dropdown-menu {
  background: #2d3748;
  border: 1px solid #4a5568;
}

.dasp-select-dark .vs__dropdown-option {
  color: #e2e8f0;
}

.dasp-select-dark .vs__dropdown-option--highlight {
  background: #007bff;
  color: white;
}

.dasp-select-dark .vs__no-options {
  color: #a0aec0;
}

.dasp-select-dark .vs__clear {
  color: #a0aec0;
}

.dasp-select-dark .vs__open-indicator {
  color: #a0aec0;
}

/* v-select Light */
.dasp-select-light .vs__dropdown-toggle {
  background: #ffffff;
  border: 1px solid #e2e8f0;
}

.dasp-select-light .vs__selected {
  color: #2d3748;
}

.dasp-select-light .vs__search::placeholder {
  color: #6c757d;
}

.dasp-select-light .vs__dropdown-menu {
  background: #ffffff;
  border: 1px solid #e2e8f0;
}

.dasp-select-light .vs__dropdown-option {
  color: #2d3748;
}

.dasp-select-light .vs__dropdown-option--highlight {
  background: #007bff;
  color: white;
}

.dasp-select-light .vs__no-options {
  color: #6c757d;
}

.dasp-select-light .vs__clear {
  color: #6c757d;
}

.dasp-select-light .vs__open-indicator {
  color: #6c757d;
}

/* Cards internos */
.dasp-inner-card-dark {
  background: #232b3e;
  border: 1px solid #4a5568;
  border-radius: 12px;
}

.dasp-inner-card-light {
  background: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 12px;
}

/* Animações para modais de confirmação */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: all 0.3s ease;
}

.modal-fade-enter-active .confirm-overlay {
  animation: fadeInOverlay 0.3s ease;
}

.modal-fade-enter-active .confirm-card {
  animation: slideInCard 0.3s ease;
}

.modal-fade-leave-active .confirm-overlay {
  animation: fadeOutOverlay 0.3s ease;
}

.modal-fade-leave-active .confirm-card {
  animation: slideOutCard 0.3s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

@keyframes fadeInOverlay {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeOutOverlay {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

@keyframes slideInCard {
  from {
    opacity: 0;
    transform: scale(0.8) translateY(-20px);
  }

  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes slideOutCard {
  from {
    opacity: 1;
    transform: scale(1) translateY(0);
  }

  to {
    opacity: 0;
    transform: scale(0.8) translateY(-20px);
  }
}

/* ===== RESPONSIVIDADE MOBILE ===== */
@media (max-width: 768px) {

  /* Ajustes gerais do container principal */
  .main-content {
    padding: 0.5rem !important;
  }

  .card {
    margin-bottom: 1rem;
    padding: 0.75rem !important;
  }

  /* Header da DASP - empilha verticalmente no mobile */
  .col-md-4,
  .col-md-8 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    margin-bottom: 0.75rem;
  }

  .col-md-8.row.justify-content-end {
    justify-content: flex-start !important;
    gap: 0.5rem;
  }

  /* Cards DASP menores no mobile */
  .dasp-card {
    padding: 1rem 0.75rem !important;
    margin-bottom: 1rem;
  }

  .dasp-card-header {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 0.5rem;
    margin-bottom: 1rem;
  }

  .dasp-card-header i {
    font-size: 18px !important;
  }

  .dasp-card-title {
    font-size: 1.1rem !important;
    margin: 0 !important;
  }

  .dasp-card-line {
    width: 100%;
    margin-left: 0 !important;
    margin-top: 0.5rem;
  }

  /* Campos do formulário em coluna única */
  .col-md-12,
  .col-md-6,
  .col-md-4,
  .col-md-3 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    margin-bottom: 0.75rem;
  }

  /* Labels menores */
  .dasp-label-dark,
  .dasp-label-light {
    font-size: 0.9rem;
    margin-bottom: 0.25rem;
  }

  /* Inputs e selects mais compactos */
  .form-control,
  .vs__dropdown-toggle {
    padding: 0.5rem !important;
    font-size: 0.9rem;
  }

  /* Tabelas responsivas */
  .table-responsive {
    border: none;
    margin: 0 -0.75rem;
    overflow-x: auto;
  }

  .table {
    font-size: 0.7rem;
    margin-bottom: 0.5rem;
    min-width: 100%;
    white-space: nowrap;
  }

  .table th,
  .table td {
    padding: 0.25rem 0.125rem !important;
    border-radius: 0 !important;
    vertical-align: middle;
    font-size: 0.65rem;
    min-width: 80px;
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* Tabela de produtos - colunas mais estreitas */
  .tabela-leitura {
    min-width: 1000px !important;
  }

  .tabela-leitura th,
  .tabela-leitura td {
    font-size: 0.75rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* Larguras específicas para mobile */
  .tabela-leitura th:nth-child(1),
  .tabela-leitura td:nth-child(1) {
    min-width: 150px;
    max-width: 200px;
  }

  .tabela-leitura th:nth-child(2),
  .tabela-leitura td:nth-child(2) {
    min-width: 130px;
    max-width: 180px;
  }

  /* Coluna de ações menor */
  .tabela-leitura th:last-child,
  .tabela-leitura td:last-child {
    min-width: 60px;
    max-width: 80px;
  }

  /* Para a tabela de fornecedores/pagamentos - também mais compacta */
  .supplier-table-container {
    overflow-x: auto !important;
    margin: 0 -0.75rem;
  }

  .supplier-table-container .table {
    font-size: 0.65rem;
    min-width: 600px;
  }

  .supplier-table-container .table th,
  .supplier-table-container .table td {
    padding: 0.25rem 0.125rem !important;
    min-width: 70px !important;
    max-width: 100px !important;
    font-size: 0.65rem;
  }

  /* Ajusta inputs dentro das tabelas para mobile */
  .table .form-control,
  .table .form-control-sm {
    font-size: 0.65rem;
    padding: 0.25rem;
    min-width: 50px;
    width: 100%;
  }

  /* v-select nas tabelas menor */
  .table .vs__dropdown-toggle {
    min-height: 28px !important;
    font-size: 0.65rem;
    padding: 0.125rem 0.25rem;
  }

  .table .vs__selected {
    font-size: 0.6rem;
  }

  /* Botões dentro da tabela menores */
  .table .btn-remove {
    width: 24px;
    height: 24px;
    font-size: 0.6rem;
  }

  .table input[type="checkbox"] {
    transform: scale(0.8);
  }

  /* Botões menores e organizados */
  .btn {
    padding: 0.375rem 0.75rem;
    font-size: 0.875rem;
    margin-bottom: 0.25rem;
  }

  .btn-group {
    flex-direction: column;
    width: 100%;
  }

  .btn-group .btn {
    border-radius: 0.25rem !important;
    margin-bottom: 0.25rem;
  }

  /* Toolbar responsiva */
  .toolbar {
    flex-direction: column !important;
    gap: 0.5rem;
  }

  .toolbar-left,
  .toolbar-right {
    width: 100%;
    justify-content: center;
    flex-wrap: wrap;
  }

  /* Modal ajustado para mobile */
  .modal-dialog {
    margin: 0.5rem !important;
    max-width: calc(100% - 1rem) !important;
  }

  .modal-content {
    border-radius: 0.5rem;
  }

  .modal-body {
    padding: 1rem 0.75rem;
  }

  /* Textarea do modal menor */
  .modal-footer textarea {
    margin-bottom: 0.75rem;
    min-height: 80px;
  }

  /* Badge de status maior e mais visível */
  .badge {
    padding: 0.5rem 0.75rem;
    font-size: 0.875rem;
  }

  /* Botão de notas mais visível */
  .btn-add.btn-crud {
    padding: 0.5rem !important;
    width: 40px;
    height: 40px;
  }

  .notification-badge {
    top: -2px;
    right: 2px;
    font-size: 0.7rem;
  }

  /* Fotos menores no mobile */
  .photo {
    width: 40% !important;
    max-width: 200px !important;
  }

  .photo-title {
    width: 40% !important;
    font-size: 0.9rem;
  }

  /* Remove margens excessivas */
  .mt-4 {
    margin-top: 1rem !important;
  }

  .mb-4 {
    margin-bottom: 1rem !important;
  }

  /* Ajusta padding dos cards internos */
  .dasp-inner-card-dark,
  .dasp-inner-card-light {
    padding: 0.75rem;
    margin-bottom: 0.75rem;
  }

  /* v-select mais compacto no mobile */
  .vs__dropdown-toggle {
    min-height: 38px !important;
  }

  .vs__selected {
    font-size: 0.875rem;
  }

  .vs__search {
    font-size: 0.875rem;
  }

  /* Confirmação modal responsiva */
  .confirm-card {
    margin: 1rem;
    min-width: auto !important;
    max-width: calc(100vw - 2rem);
    padding: 1.5rem;
  }
}

/* ===== ESTILO PARA ITENS NÃO APROVADOS ===== */
.item-not-approved {
  color: #dc3545 !important;
  /* Vermelho Bootstrap danger */
}

.item-not-approved td {
  color: #dc3545 !important;
  /* Aplica vermelho em todas as colunas */
}

.item-not-approved input,
.item-not-approved span:not(.badge) {
  color: #dc3545 !important;
  /* Aplica vermelho nos inputs e spans */
}

.item-not-approved a {
  color: #dc3545 !important;
  /* Aplica vermelho nos links */
}

/* ===== RESPONSIVIDADE TABLET ===== */
@media (min-width: 769px) and (max-width: 1024px) {
  .dasp-card {
    padding: 1.25rem;
  }

  .col-md-6 {
    flex: 0 0 50% !important;
    max-width: 50% !important;
  }

  .col-md-4 {
    flex: 0 0 50% !important;
    max-width: 50% !important;
  }

  .col-md-3 {
    flex: 0 0 50% !important;
    max-width: 50% !important;
  }

  /* Tabelas mais compactas no tablet também */
  .table {
    font-size: 0.8rem;
  }

  .table th,
  .table td {
    padding: 0.375rem 0.25rem !important;
    max-width: 140px;
  }

  .tabela-leitura {
    min-width: 900px !important;
  }

  /* Tabela de fornecedores no tablet */
  .supplier-table-container .table {
    font-size: 0.8rem;
    min-width: 700px;
  }
}
</style>
